"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformForRedux = exports.formatTransformedEventsWithCollection = void 0;

var _transformationUtils = require("@eb/transformation-utils");

var _normalizr = require("normalizr");

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var formatTransformedEventsWithCollection = function formatTransformedEventsWithCollection(events, eventIds) {
  var formattedEvents = {};
  (0, _forEach.default)(eventIds, function (eventId) {
    var _events$eventId = events[eventId],
        _events$eventId$myCol = _events$eventId.myCollections;
    _events$eventId$myCol = _events$eventId$myCol === void 0 ? {} : _events$eventId$myCol;

    var _events$eventId$myCol2 = _events$eventId$myCol.collections,
        collections = _events$eventId$myCol2 === void 0 ? [] : _events$eventId$myCol2,
        eventData = _objectWithoutProperties(_events$eventId, ["myCollections"]);

    var collectionIds = collections.map(function (_ref) {
      var id = _ref.id;
      return id;
    });
    formattedEvents = _objectSpread(_objectSpread({}, formattedEvents), {}, _defineProperty({}, eventId, _objectSpread({
      eventCollections: collectionIds
    }, eventData)));
  });
  return formattedEvents;
};
/*
 * @param eventResponse -- {events: [{event_object}], pagination: {paginationObject}}
 *
 * returns
 * {
 *   events: {
 *     eventId: {eventObject},
 *     eventId: {}...
 *   },
 *   ids: [string],
 *   continuation: number,
 *   pageCount: number,
 *   totalItems: number,
 * }
 */


exports.formatTransformedEventsWithCollection = formatTransformedEventsWithCollection;

var transformForRedux = function transformForRedux() {
  var eventResponse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _eventResponse$events = eventResponse.events,
      events = _eventResponse$events === void 0 ? {} : _eventResponse$events,
      _eventResponse$pagina = eventResponse.pagination,
      pagination = _eventResponse$pagina === void 0 ? {} : _eventResponse$pagina;
  var content = new _normalizr.Schema('events');
  /* Parse the events into by ID entities */

  var _transformUtil = (0, _transformationUtils.transformUtil)({
    response: {
      events: events
    },
    schema: {
      events: (0, _normalizr.arrayOf)(content)
    }
  }),
      _transformUtil$entiti = _transformUtil.entities;

  _transformUtil$entiti = _transformUtil$entiti === void 0 ? {} : _transformUtil$entiti;
  var normalizedEvents = _transformUtil$entiti.events,
      normalizedEventIds = _transformUtil.result.events;
  var normalizedEventsWithFormattedCollection = formatTransformedEventsWithCollection(normalizedEvents, normalizedEventIds);
  /* Build pagination object */

  var hasMoreItems = pagination.has_more_items,
      totalItems = pagination.object_count,
      continuation = pagination.continuation;
  return {
    events: normalizedEventsWithFormattedCollection,
    ids: (0, _isEmpty.default)(normalizedEventIds) ? [] : normalizedEventIds,
    hasMoreItems: hasMoreItems,
    continuation: continuation,
    totalItems: totalItems
  };
};

exports.transformForRedux = transformForRedux;
//# sourceMappingURL=utils.js.map